import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './styles/Register.css';
import HeaderNew from '../../components/HeaderNew';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import { Circles, ThreeCircles } from 'react-loader-spinner';
import service from '../../services/service';
import useNonce from '../../helper/Nonce';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import { formFields } from './formConfig.js';
import { color } from 'highcharts';

const Register = () => {
  // const fetchAndSetNonce = useNonce();
  const history = useHistory();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ show: false, message: '', type: '' });
  const [fieldStates, setFieldStates] = useState({
    otherCountryVisible: false,
    // instituteNameVisible: false
    // organizationNameDisabled: true,
    // organizationNameVisible: false, //// CONDITIONAL VISIBILITY OF FIELDS //// NOT IN USE NOW
  });

  const [allCountries, setAllCountries] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allNationalities, setAllNationalities] = useState([]);
  const [allQualifications, setAllQualifications] = useState([]);
  const [allDesignations, setAllDesignations] = useState([]);
  const [allOrganizations, setAllOrganizations] = useState([]);

  const [data, setData] = useState();
  const [captchaHash, setCaptchaHash] = useState();
  const [captchaToken, setCaptchaToken] = useState();
  const [captchaKey, setCaptchaKey] = useState();
  const [inputCaptcha, setInputCaptcha] = useState();

  ///////////// OTP CODE //////////////////////////////

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpError, setOtpError] = useState({ message: "" })
  const isMobile = (value) => /^[0-9]{10}$/.test(value);
  const [otpData, setOtpData] = useState({
    showModal: false,
    sendTo: "",
    otpCode: "",
    isOtpResend: false,
    // isMobileVerify: false,
    isEmailVerify: false
  })
  const inputs = useRef([]);
  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/, "");
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const onClickVerify = () => {

    if (verifyLoading) return;

    const otpCode = otp.join("");
    const filledLength = otp.filter((digit) => digit !== "").length;

    //console.log("Filled length =", filledLength);
    //console.log("OTP =", otpCode);

    if (filledLength === 6) {
      setVerifyLoading(true);
      setOtpData((prev) => ({
        ...prev,
        isOtpFill: false
      }))

      const data = {
        sendTo: otpData.sendTo,
        otpCode: otpCode
      }
      service.validateOTP(data).then((resp) => {
        if (resp.status == 200) {
          if (resp.data?.verified) {
            setOtpData((prev) => ({
              ...prev,
              // isMobileVerify: otpData.isMobileVerify == true ? true : isMobile(otpData.sendTo) ? true : false,
              isEmailVerify: otpData.isEmailVerify == true ? true : isMobile(otpData.sendTo) ? false : true,
              isOtpFill: false,
              sendTo: "",
              showModal: false,
              otpCode: ""
            }))
            setOtpError((prev) => ({
              ...prev,
              message: ""
            }))
            Swal.fire({
              icon: "success",
              title: "OTP Status",
              text: isMobile(otpData.sendTo) ? "Mobile number is verified successfully." : "Email Id is verified successfully."
            })
            setOtp(["", "", "", "", "", ""])
          }
        }
      }).catch((error) => {
        if (error.response.status == 400) {
          setOtpError((prev) => ({
            ...prev,
            message: error.response.data?.message
          }))
        }
      }).finally(() => {
        setVerifyLoading(false); // stop loading
      });

    } else {
      setOtpError((prev) => ({
        ...prev,
        message: "OTP field is empty"
      }))
    }
  }

  const onClickResendButton = () => {
    setOtp(["", "", "", "", "", ""]);

    if (resendLoading) return;

    setResendLoading(true);

    const data = {
      sendTo: otpData.sendTo
    }
    service.sendOTP(data).then((resp) => {
      if (resp.status == 200) {
        setOtpData((prev) => ({
          ...prev,
          showModal: true,
          // isMobileVerify: false,
          isOtpResend: true,
          otpCode: ""
        }))
        setOtpError((prev) => ({
          ...prev,
          message: resp.data?.message
        }))
      }
    }).catch((error) => {
      if (error.response.status == 400) {
        Swal.fire({
          icon: "error",
          title: "OTP Status",
          text: error.response.data?.message
        })
      }
    })
      .finally(() => {
        setResendLoading(false); // stop loading
      });

  }

  // const onClickMobileOtpHandler = (sendTo) => {
  //   if (sendTo) {
  //     const data = {
  //       sendTo: sendTo
  //     }
  //     service.sendOTP(data).then((resp) => {
  //       setOtpData((prev) => ({
  //         ...prev,
  //         showModal: true,
  //         sendTo: sendTo
  //       }))
  //       if (resp.status == 200) {
  //         if (resp.data?.verified === true) {
  //           Swal.fire({
  //             icon: 'info',
  //             title: "OTP Status",
  //             text: isMobile(sendTo) ? "This mobile number is already verified." : "This Email Id is already verified."
  //           })
  //           setOtpData((prev) => ({
  //             ...prev,
  //             sendTo: "",
  //             showModal: false,
  //             // isMobileVerify: true,
  //             otpCode: ""
  //           }))
  //           setOtpError((prev) => ({
  //             ...prev,
  //             message: ""
  //           }))
  //         }
  //         else {
  //           setOtpData((prev) => ({
  //             ...prev,
  //             sendTo: sendTo,
  //             showModal: true,
  //             isMobileVerify: false,
  //             otpCode: ""
  //           }))
  //           setOtpError((prev) => ({
  //             ...prev,
  //             message: ""
  //           }))
  //         }
  //       }
  //     }).catch((error) => {
  //       if (error.response.status == 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "OTP Status",
  //           text: error.response.data?.message
  //         })
  //       }
  //     })
  //   }
  // }

  const [otpLoading, setOtpLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  const onClickEmailOtpHandler = (e, sendto) => {
    e.preventDefault();
    if (!sendto || otpLoading) return;

    if (sendto) {
      setOtpLoading(true);
      const data = {
        sendTo: sendto
      }
      service.sendOTP(data).then((resp) => {
        if (resp.status == 200) {
          setOtpData((prev) => ({
            ...prev,
            showModal: true,
            sendTo: sendto
          }))
          if (resp.data?.verified === true) {
            Swal.fire({
              icon: 'info',
              title: "OTP Status",
              text: isMobile(sendto) ? "This mobile number is already verified." : "This Email Id is already verified."
            })
            setOtpData((prev) => ({
              ...prev,
              sendTo: "",
              showModal: false,
              isEmailVerify: true,
              otpCode: ""
            }))
            setOtpError((prev) => ({
              ...prev,
              message: ""
            }))
          }
          else {
            setOtpData((prev) => ({
              ...prev,
              sendTo: sendto,
              showModal: true,
              isEmailVerify: false,
              otpCode: ""
            }))
            setOtpError((prev) => ({
              ...prev,
              message: ""
            }))
          }
        }
      }).catch((error) => {
        if (error.response.status == 400) {
          Swal.fire({
            icon: "error",
            title: "OTP Status",
            text: error.response.data?.message
          })
        }
      })
        .finally(() => {
          setOtpLoading(false); // always re-enable button
        });
    }
  }

  ///////////////////// OTP CODE ////////////////////////

  useEffect(() => {
    // getCaptcha();
    getAllCountry();
    getAllStates();
    // getAllCategories();
    // getAllNationalities();
    getAllQualifications();
    getAllDesignations();
    // getAllOrganizations();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let updatedFormData = {
      ...formData,
      [name]: value
    };

    if (name === "countryId") {

      if (value === "1") {

        setFieldStates(prev => ({
          ...prev,
          stateIdVisible: true,
          stateIdRequired: true,
          countryNameVisible: false,
          countryNameRequired: false
        }));

        delete updatedFormData.countryName;

      } else {

        setFieldStates(prev => ({
          ...prev,
          stateIdVisible: false,
          stateIdRequired: false,
          countryNameVisible: true,
          countryNameRequired: true
        }));

        delete updatedFormData.stateId;
      }
    }

    // validate current field
    const error = validateField(name, value, updatedFormData);

    setErrors(prev => ({
      ...prev,
      [name]: error
    }));

    formFields.forEach((field) => {

      if (field.enabledDependencies?.field === name) {

        const shouldEnable = field.enabledDependencies.condition(value);

        setFieldStates(prev => ({
          ...prev,
          [`${field.name}Disabled`]: !shouldEnable
        }));
      }

      if (field.visibilityDependencies?.field === name) {

        const shouldShow = field.visibilityDependencies.condition(value);

        setFieldStates(prev => ({
          ...prev,
          [`${field.name}Visible`]: shouldShow
        }));
      }

      if (field.requireDependencies?.field === name) {

        const shouldRequire = field.requireDependencies.condition(value);

        setFieldStates(prev => ({
          ...prev,
          [`${field.name}Required`]: shouldRequire
        }));

        if (shouldRequire) {

          const depError = validateField(
            field.name,
            updatedFormData[field.name] || '',
            updatedFormData
          );

          setErrors(prev => ({
            ...prev,
            [field.name]: depError
          }));

        } else {

          setErrors(prev => ({
            ...prev,
            [field.name]: null
          }));
        }
      }

    });

    // finally update formData ONCE
    setFormData(updatedFormData);
  };


  const handleFileChange = (event) => {
    const { name, files } = event.target;
    const file = files[0];
    const field = formFields.find((field) => field.name === name);

    if (!file) {
      setErrors((prev) => ({ ...prev, [name]: "File is required." }));
      return;
    }

    // Validate file size
    if (file.size > field.maxSize) {
      setErrors((prev) => ({
        ...prev,
        [name]: `File size exceeds the limit of ${field.maxSize / (1024)} KB.`,
      }));
      return;
    }

    // Validate file type
    if (!field.accept.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [name]: `Invalid file type. Allowed types: ${field.accept.join(", ")}.`,
      }));
      return;
    }

    // Clear any previous errors
    setErrors((prev) => ({ ...prev, [name]: null }));

    // Update the form data
    setFormData((prev) => ({
      ...prev,
      [name]: file,
    }));
  };



  const validateField = (name, value, updatedFormData = formData) => {

    // Country → State logic
    if (name === "stateId") {
      const countryId = updatedFormData.countryId || "";
      if (countryId === "1" && (!value || value === "")) {
        return "State is required";
      }
      return null;
    }

    // Country → Country Name logic
    if (name === "countryName") {
      const countryId = updatedFormData.countryId || "";
      if (countryId !== "1" && (!value || value.trim() === "")) {
        return "Country Name is required";
      }
      return null;
    }

    const field = formFields.find((f) => f.name === name);

    if (!field) return null;

    // FIX: determine required using updatedFormData logic instead of fieldStates
    let isRequired = field.required;

    if (field.requireDependencies) {
      const depField = field.requireDependencies.field;
      const depValue = updatedFormData[depField];
      isRequired = field.requireDependencies.condition(depValue);
    }

    if (isRequired) {

      if (field.type === 'file' && (!value || value.length === 0)) {
        return `${field.label} is required`;
      }

      if (field.type === 'select' && (!value || value === '')) {
        return `${field.label} is required`;
      }

      if (typeof value === 'string' && value.trim() === '') {
        return `${field.label} is required`;
      }
    }

    // regex validation
    if (value && field.validation?.regex && !field.validation.regex.test(value)) {
      return field.validation.errorMessage;
    }

    // custom validation
    if (value && field.validation?.custom && !field.validation.custom(value)) {
      return field.validation.errorMessage;
    }

    return null;
  };


  const getAllCountry = () => {
    setPageLoading(true);
    service.getCountry()
      .then((res) => {
        setAllCountries(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Country Data", "error");
      })
  }

  const getAllStates = () => {
    setPageLoading(true);
    service.getState()
      .then((res) => {
        setAllStates(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load States Data", "error");
      })
  }

  const getAllNationalities = () => {
    setPageLoading(true);
    service.getAllUserNationality()
      .then((res) => {
        setAllNationalities(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load States Data", "error");
      })
  }

  const getAllQualifications = () => {
    setPageLoading(true);
    service.RegisterQualification()
      .then((res) => {
        setAllQualifications(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Qualification Data", "error");
      })
  }

  const getAllDesignations = () => {
    setPageLoading(true);
    service.RegisterDesignation()
      .then((res) => {
        setAllDesignations(res.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Qualification Data", "error");
      })
  }

  const getAllOrganizations = () => {
    setPageLoading(true);
    service.getAllOrganizations()
      .then((res) => {
        setAllOrganizations(res.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Qualification Data", "error");
      })
  }

  const getAllCategories = () => {
    setPageLoading(true);
    service.getAllUserCategory()
      .then((res) => {
        setAllCategories(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load States Data", "error");
      })
  }

  // const handleRefereshCaptcha = () => {
  //   setCaptchaLoading(true);
  //   service.getRegisterCaptcha()
  //     .then((res) => {
  //       //console.log(res.data);
  //       setData(res.data.captchaImage);
  //       setCaptchaHash(res.data.captchaHash);
  //       setCaptchaToken(res.data.captchaToken);
  //       setCaptchaKey(res.data.captchaKey);
  //       setCaptchaLoading(false);
  //     }).catch((err) => {

  //       setCaptchaLoading(false);
  //       // swal(t('error'), "Failed to load Captcha", "error");
  //     })
  // }

  // const autoRefereshCaptcha = () => {
  //   service.getRegisterCaptcha().then((res) => {
  //     setData(res.data.captchaImage);
  //     setCaptchaHash(res.data.captchaHash);
  //     setCaptchaToken(res.data.captchaToken);
  //     setCaptchaKey(res.data.captchaKey);
  //   });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!otpData.isEmailVerify) {
      Swal.fire({
        icon: "warning",
        title: "Email not verified",
        text: "Please verify your email before registering."
      });
      return;
    }
    const validationErrors = {};

    // Validate each field and store errors in validationErrors
    formFields.forEach(({ name }) => {
      const error = validateField(name, formData[name] || '');
      if (error) validationErrors[name] = error;
    });

    // Validate captcha fields
    // if (!inputCaptcha || inputCaptcha.trim() === '') {
    //   validationErrors.inputCaptcha = "Captcha is Required"; // Add a translation key for this
    // }

    // if (!captchaHash || !captchaToken || !captchaKey) {
    //   validationErrors.captcha = "Invalid Captcha"; // Add a translation key for this
    // }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSubmitStatus({
        show: true,
        message: 'Please fix the errors and try again.',
        type: 'danger'
      });
      Swal.fire({
        title: "Warning",
        text: "Please fix the errors and try again.",
        icon: "warning",
        showConfirmButton: true,
        showCloseButton: true,
      });
      return;
    }

    setLoading(true);
    setPageLoading(true);

    // Create a FormData object for multipart/form-data
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    if (formData.countryId === "1") {

      if (!formData.stateId) {

        Swal.fire({
          icon: "warning",
          title: "State required",
          text: "Please select state"
        });

        setLoading(false);
        setPageLoading(false);
        return;
      }

    } else {

      // remove stateId
      formDataToSend.delete("stateId");

      // add countryName
      const selectedCountry = allCountries.find(
        c => String(c.countryId) === String(formData.countryId)
      );

      if (selectedCountry) {
        formDataToSend.append("countryName", selectedCountry.countryName);
      }
    }


    // Add captcha fields to formDataToSend
    // formDataToSend.append("captchaInput", inputCaptcha.trim());
    // formDataToSend.append("captchaHash", captchaHash);
    // formDataToSend.append("captchaToken", captchaToken);
    // formDataToSend.append("captchaKey", captchaKey);

    // Ensure service.Register sends data as multipart
    service.Register(formDataToSend)
      .then(async (response) => {
        if (response.data == null || response.data == undefined) {
          swal(
            t("error"),
            t("unexpected_error_message"), // Customize this to your translation key
            "error"
          ).then(() => {
            setLoading(false);
            // autoRefereshCaptcha();
          });
        }
        if (response.status === 200) {
          setLoading(false);
          setPageLoading(false);
          if (response.data === 'User-already-Exist') {
            swal(
              t("error"),
              'A user with this information already exists. Please use a different username or email address!', // Customize this to your translation key
              "warning"
            ).then(() => {
              history.push("/");
            });
          } else {
            Swal.fire({
              title: t("reg_success"),
              text: t("reg_success_desc"),
              icon: "success",
              showConfirmButton: false,
              timer: 10000,
            }).then(() => {
              history.push("/");
            });
          }

        }
      })
      .catch((err) => {
        setLoading(false);
        //console.log("ERROR ====>", err);

        if (err.response && err.response.data) {
          const { status, data } = err.response;

          // Show error message from the server if available
          if (status >= 400 && status < 500) {
            swal(t("warning"), data.message || data, "warning")
              .then(() => {
                setLoading(false);
                // autoRefereshCaptcha();
              });
          } else {
            // Fallback for server errors (500 and above) or unexpected cases
            swal(
              t("error"),
              t("unexpected_error_message"), // Customize this to your translation key
              "error"
            ).then(() => {
              setLoading(false);
              // autoRefereshCaptcha();
            });
          }
        } else {
          // Fallback for network errors or unhandled cases
          swal(
            t("error"),
            t("network_error"), // Customize this to your translation key
            "error"
          ).then(() => {
            setLoading(false);
            // autoRefereshCaptcha();
          });
        }
      });
    setLoading(false);
  };

  const groupedFields = formFields.reduce((groups, field) => {
    const { row = 1 } = field;
    if (!groups[row]) groups[row] = [];
    groups[row].push(field);
    return groups;
  }, {});

  return (
    <div className="main-registration-page">
      <HeaderNew />
      <div style={{ paddingTop: "140px" }} />
      <BreadcrumbBox title={t('registration')} />
      {pageLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)', // Adjust the transparency as needed
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000, // Ensure it's above other elements
          }}
        >
          {/* Loader */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Circles height={40} width={40} color="#4fa94d" ariaLabel="circles-loading" />
          </div>
        </div>
      )}

      <Container fluid className="registration-area">
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <Card className="registration-card">
              <Card.Header className="text-center border-0 bg-transparent pt-4">
                <div className="registration-title">
                  <h2>{t('registration')}</h2>
                </div>
              </Card.Header>
              <Card.Body className="px-4 py-4">
                {/* {submitStatus.show && (
                  <Alert
                    variant={submitStatus.type}
                    onClose={() => setSubmitStatus({ ...submitStatus, show: false })}
                    dismissible
                    className="mb-4"
                  >
                    {submitStatus.message}
                  </Alert>
                )} */}

                <Form>
                  {Object.entries(groupedFields).map(([row, fields]) => (
                    <Row key={row} className="mb-3">
                      {fields.map((field) => {
                        // const isVisible = fieldStates[`${field.name}Visible`] !== false; // Default is true unless explicitly set to false

                        const isVisible =
                          field.name === "stateId"
                            ? formData.countryId === "1"
                            : field.name === "countryName"
                              ? formData.countryId !== "1"
                              : fieldStates[`${field.name}Visible`] !== false;

                        const isDisabled = fieldStates[`${field.name}Disabled`] === true;

                        return (
                          isVisible && (
                            <Col key={field.name} md={field.col || 6} sm={12}>
                              <Form.Group className="form-group">
                                <div className="d-flex align-items-center">
                                  <Form.Label className="form-label mb-0">
                                    {t(field.label)}
                                    {field.required && <span className="text-danger">*</span>}
                                  </Form.Label>
                                  {field.infoTop && (
                                    <div className="field-top-info ms-3">
                                      <p className="text-muted mb-0">{field.infoTop.message}</p>
                                      {field.infoTop.link && (
                                        <a
                                          href={field.infoTop.link.url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="d-block text-primary mt-1"
                                        >
                                          {field.infoTop.link.text}
                                        </a>
                                      )}
                                    </div>
                                  )}
                                </div>
                                {field.type === "file" ? (
                                  <Form.Control
                                    className="form-media"
                                    type="file"
                                    name={field.name}
                                    accept={field.accept.join(",")}
                                    onChange={handleFileChange}
                                    isInvalid={!!errors[field.name]}
                                    disabled={field.isDisabled}
                                  />
                                ) : field.type === 'select' ? (
                                  <Form.Select
                                    className="form-select"
                                    name={field.name}
                                    value={formData[field.name] || ''}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors[field.name]}
                                    disabled={field.isDisabled}
                                  >
                                    <option value="">{`Select ${field.label}`}</option>

                                    {(() => {
                                      // Select the correct array of options based on the field name
                                      const options =
                                        field.name === 'qualId' ? allQualifications :
                                          field.name === 'userNationality' ? allNationalities :
                                            field.name === 'userCategory' ? allCategories :
                                              field.name === 'desgId' ? allDesignations :
                                                field.name === 'countryId' ? allCountries :
                                                  field.name === 'stateId' ? allStates :
                                                    field.name === 'orgId' ? allOrganizations :
                                                      field.options; // Fallback for static options if available

                                      // Render the options with appropriate label and value fields
                                      return options.map((option, index) => (
                                        <option
                                          key={index}
                                          value={
                                            option.qualId ||
                                            option.userNationalityId ||
                                            option.userCategoryId ||
                                            option.desgId ||
                                            option.countryId ||
                                            option.stateId ||
                                            option.orgId ||
                                            option.value ||
                                            option
                                          }
                                        >
                                          {option.qualification ||
                                            option.userNationalityName ||
                                            option.userCategoryName ||
                                            option.designation ||
                                            option.countryName ||
                                            option.stateName ||
                                            option.orgName ||
                                            option.label ||
                                            option
                                          }
                                        </option>
                                      ));
                                    })()}
                                  </Form.Select>
                                ) :
                                  <>
                                    {
                                      field.name === "mobile" ?
                                        <>
                                          <div className="d-flex">
                                            <Form.Control
                                              className="form-input"
                                              type={field.type}
                                              name={field.name}
                                              placeholder={field.placeholder}
                                              value={formData[field.name] || ''}
                                              onChange={(handleInputChange)}
                                              isInvalid={!!errors[field.name]}
                                              maxLength={field.maxLength}
                                              disabled={field.isDisabled}
                                            />
                                            {/* {
                                              otpData.isMobileVerify ?
                                                <>
                                                  <div className='otp-verify'>
                                                    <i className="fa fa-check-circle success-icon"></i>
                                                  </div>
                                                </>
                                                :
                                                <>
                                                  <Button
                                                    variant="success"
                                                    className="ms-2 send-otp-btn"
                                                    onClick={() => onClickMobileOtpHandler(formData.mobile)}
                                                  // disabled={!formData.mobile || errors.mobile}
                                                  >
                                                    Send OTP
                                                  </Button>
                                                </>
                                            } */}
                                          </div>
                                        </>
                                        :
                                        <>
                                          {
                                            field.name === "email" ?
                                              <>
                                                <div className="d-flex">
                                                  <Form.Control
                                                    className="form-input"
                                                    type={field.type}
                                                    name={field.name}
                                                    placeholder={field.placeholder}
                                                    value={formData[field.name] || ''}
                                                    onChange={handleInputChange}
                                                    isInvalid={!!errors[field.name]}
                                                    maxLength={field.maxLength}
                                                    disabled={field.isDisabled}
                                                  />
                                                  {
                                                    otpData.isEmailVerify ?
                                                      <>
                                                        <div className='otp-verify'>
                                                          <i className="fa fa-check-circle success-icon"></i>
                                                        </div>
                                                      </>
                                                      :
                                                      <>
                                                        <Button
                                                          variant="success"
                                                          className="ms-2 send-otp-btn"
                                                          onClick={(e) => onClickEmailOtpHandler(e, formData.email)}
                                                          disabled={otpLoading || !formData.email || errors.email}
                                                        >
                                                          {otpLoading ? "Sending..." : "Send OTP"}
                                                        </Button>
                                                      </>
                                                  }

                                                </div>
                                              </>
                                              :
                                              <>
                                                <>
                                                  <Form.Control
                                                    className="form-input"
                                                    type={field.type}
                                                    name={field.name}
                                                    placeholder={field.placeholder}
                                                    value={formData[field.name] || ''}
                                                    onChange={handleInputChange}
                                                    isInvalid={!!errors[field.name]}
                                                    maxLength={field.maxLength}
                                                    disabled={field.isDisabled}
                                                  />
                                                </>
                                              </>
                                          }
                                        </>
                                    }
                                  </>
                                }
                                {/* Display Info (Message or Link) */}
                                {field.infoBottom && (
                                  <div className="field-bottom-info mt-2">
                                    <p className="text-muted mb-0">{field.infoBottom.message}</p>
                                    {field.infoBottom.link && (
                                      <a
                                        href={field.infoBottom.link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="d-block text-primary mt-1"
                                      >
                                        {field.infoBottom.link.text}
                                      </a>
                                    )}
                                  </div>
                                )}
                                <Form.Control.Feedback type="invalid">
                                  {errors[field.name]}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          )
                        );
                      })}
                    </Row>
                  ))}

                  {/* <div className="captcha-container d-flex">
                    <div>
                      {captchaLoading ? (
                        <ThreeCircles
                          height="40"
                          width="100"
                          color="#4fa94d"
                          visible={true}
                          ariaLabel="three-circles-rotating"
                        />
                      ) : (
                        <img src={`data:image/jpeg;base64,${data}`} className="captcha-image" alt="Captcha" />
                      )}
                    </div>
                    <div>
                      <button
                        className="captcha-refresh-btn"
                        onClick={handleRefereshCaptcha}
                        type="button"
                      >
                        <i className="fa fa-refresh"></i>
                      </button>
                    </div>
                    <div>
                      <div className="form-group">
                        <input
                          type="text"
                          name="inputCaptcha"
                          value={inputCaptcha}
                          placeholder={t('captcha')}
                          onChange={(e) => setInputCaptcha(e.target.value)}
                          className={`captcha-input ${errors.inputCaptcha ? 'error' : inputCaptcha ? 'success' : ''}`}
                          minLength="4"
                          maxLength="7"
                        />
                        {errors.inputCaptcha && <p className="captcha-input-msg">{errors.inputCaptcha}</p>}
                        {errors.captcha && <p className="captcha-error-msg">{errors.captcha}</p>}
                      </div>
                    </div>
                  </div> */}

                  {/* OTP Verification Warning Message */}
                  {!otpData.isEmailVerify && (
                    <p className="text-danger text-center mt-3">
                      Please verify your email before registering.
                    </p>
                  )}

                  <button
                    type="button"
                    className="submit-button w-100 mt-4"
                    disabled={loading || otpData.isEmailVerify !== true}
                    style={{
                      background: 'linear-gradient(90deg, #11B67A 0%, #009444 100%)',
                      color: 'white',
                      opacity: (loading || otpData.isEmailVerify !== true) ? 0.6 : 1,
                      cursor: (loading || otpData.isEmailVerify !== true) ? "not-allowed" : "pointer"
                    }}
                    onClick={handleSubmit}
                  >
                    {loading ? (
                      <span className="d-flex align-items-center justify-content-center">
                        <span className="spinner-border spinner-border-sm me-2" />
                        {t('loading')}
                      </span>
                    ) : (
                      t('register_now')
                    )}
                  </button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal centered show={otpData.showModal}
        onHide={() => {
          setOtpData((prev) => ({
            ...prev,
            showModal: false,
            sendTo: "",
            otpCode: "",
            isOtpResend: false
          }))
          setOtpError((prev) => ({
            ...prev,
            message: ""
          }))
          setOtpLoading(false);
          setVerifyLoading(false);   // ADD THIS
          setResendLoading(false);   // ADD THIS

          setOtp(["", "", "", "", "", ""]); // clear OTP boxes
        }}
        backdrop="static" size="md">
        <Modal.Header closeButton>
          <Modal.Title style={{ textAlign: "center", width: "100%" }}>
            Enter OTP
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center">
            <p className="text-muted mb-4">
              Please enter the 6-digit code sent to your registered email or phone.
            </p>
            {
              otpError.message ?
                <>
                  {
                    otpData.isOtpResend ?
                      <>
                        <p className="text-success mb-4">
                          {otpError.message}
                        </p>
                      </>
                      :
                      <>
                        <p className="text-danger mb-4">
                          {otpError.message}
                        </p>
                      </>
                  }
                </>
                :
                <></>
            }

            <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px", marginBottom: "20px" }}>
              {
                otp.map((data, index) => {
                  return (
                    <>
                      <Form.Control
                        key={index}
                        type="text"
                        maxLength="1"
                        value={data}
                        ref={(el) => (inputs.current[index] = el)}
                        onChange={(e) => handleChange(e.target, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className="text-center fs-4 fw-semibold border rounded shadow-sm otp-input"
                        style={{ width: "45px", height: "55px", textAlign: "center", fontSize: "20px", borderRadius: "8px", border: "1px solid #ced4da", boxShadow: "0 0 3px rgba(0,0,0,0.1)", outline: "none" }}
                      />
                    </>
                  )
                })
              }
            </div>
            <Button onClick={() => { onClickVerify() }} variant="success" size="lg" className="px-5 rounded fw-bold" disabled={verifyLoading}>
              {verifyLoading ? "Verifying..." : "Verify"}
            </Button>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: "center" }}>
          <Button variant="link" className="text-decoration-none fw-semibold" onClick={() => {
            onClickResendButton()
          }} disabled={resendLoading}>
            {resendLoading ? "Sending..." : "Resend OTP"}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Register;